import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import { Page, PageRequestParams } from '../../common/queryClient';
import { createApiQueryHook } from '../../common/queryClient/createApiQueryHook';
import { DataObjectGroupProcessingStateFilter } from '../../input-data/schema/types';
import { OutputDataObjectGroupProcessingStateType } from '../schema/types';
import { OutputDataUrl } from './OutputDataUrl';
import { OutputDataObjectGroupProcessingStatePageSchema } from '../schema/OutputDataObjectGroupProcessingStateSchema';

type AggregatesQueryParams = DataObjectGroupProcessingStateFilter &
  PageRequestParams;

const getOutputDataAggregates = (params?: AggregatesQueryParams) =>
  apiClient
    .get<
      Page<OutputDataObjectGroupProcessingStateType>
    >(expand(OutputDataUrl.OUTPUT_DATA_GROUP_PROCESSING_STATES, params))
    .then((response) =>
      OutputDataObjectGroupProcessingStatePageSchema.parse(response.data),
    );

export const useOutputDataGroupProcessingStateQuery = createApiQueryHook(
  ['outputDataAggregates'],
  getOutputDataAggregates,
);
